import { Page } from '@shared/interfaces/Pages'
import { tagTheme } from '@taglivros/tag-components'
import styled from 'styled-components'

const Container = styled.div<Container.Props>`
  margin-top: -1px;
  border-top: solid 2px ${props => props.$page === 'home' ? 'none' : props.theme.cores[ props.$border ]};
  padding: ${props => props.$page === 'home' ? '40px 60px 24px 24px' : '40px 24px'};
  background-color: ${props => props.$page === 'home' ? 'transparent' : props.theme.cores[ props.$color ]};

  @media (min-width: 992px) {
    padding: ${props => props.$page === 'home' ? '40px 0 0' : '45px 120px'};
    margin-top: ${props => props.$page === 'home' ? '-40px' : '-1px'};
  }
`

namespace Container {
  export interface Props {
    $color: keyof typeof tagTheme.cores
    $border: keyof typeof tagTheme.cores
    $page: Page
  }
}

const Wave = styled.div<Wave.Props>`
  height: 20px;
  border-radius:  0  0 100% 100%;
  margin-bottom: -50px;
  background-color: ${props => props.theme.cores[ props.$color ]};
  @media (min-width: 992px) {
    margin-bottom: -80px;
  }
`

namespace Wave {
  export interface Props {
    $color: keyof typeof tagTheme.cores
  }
}

const Highlight = styled.strong`
  font-family: 'Roboto Slab', serif;
  font-weight: bold;
  color: #B74D00;
`

const WrapperHeader = styled.div<WrapperHeader.Props>`
  position: relative;
  display: flex;
  flex-direction: column;
  max-width: 1200px;
  margin: auto;
  .how-it-works-header__highlight {
    font-weight: bold;
    font-family: 'Roboto Slab', serif;
    color: ${props => props.theme.cores[ props.$page === 'curadoria' ? 'TAG1-700' : 'TAG2-700' ]};
  }
  > h2 {
    max-width: 500px;
    margin-top: 8px;
    font-weight: 300;
    font-family: 'Roboto Slab', serif;
    font-size: 32px;
    line-height: 48px;
    letter-spacing: -0.01em;

    @media (min-width: 992px) {
      font-size: 40px;
    }
  }
  > svg { 
    width: 35px;
    align-self: flex-end;
    margin: -41px 0 -20px;
    @media (min-width: 992px) {
      width: 67px;
      margin: -46px 0 -70px;
    }
  }
`
namespace WrapperHeader {
  export interface Props {
    $page: Page
  }
}
export { Container, Highlight, Wave, WrapperHeader }
